import { SkinnableComponent } from '../../../types/component-skin';
import { COMPONENT_TYPES } from '../../../constants';
import { useRecommendedUsersLogic } from './RecommendedUsersLogic';
import BasicRecommendedUsersSkin from './skins/BasicRecommendedUsersSkin';

export const RecommendedUsersSkinnable: SkinnableComponent = {
  type: COMPONENT_TYPES.RECOMMENDED_USERS,
  name: '피추천인 목록',
  category: 'mlm',
  options: [],
  defaultSkin: 'basic',
  internalSkins: {
    basic: BasicRecommendedUsersSkin as any
  },
  useLogic: useRecommendedUsersLogic as any,
  defaultProps: {
    // 스킨 옵션
    title: '피추천인 목록',
    emptyText: '데이터가 없습니다',
    loadingText: '로딩 중...',
    loginRequiredText: '로그인이 필요합니다.',
    
    // 표시 옵션
    showTotalCount: true,
    showUserIds: true,
    showUserNames: true,
    showCreatedDate: true,
    showPagination: true,
    itemsPerPage: 10,
    
    // 레이아웃 옵션
    listLayout: 'card', // 'card', 'list', 'table'
    showAvatars: false,
    compactMode: false,
    
    // 색상 테마
    backgroundColor: '#ffffff',
    borderColor: '#e0e0e0',
    textColor: '#333333',
    titleColor: '#2c3e50',
    primaryColor: '#3f51b5',
    secondaryColor: '#6c757d',
    successColor: '#28a745',
    
    // 아이템 스타일
    itemBackgroundColor: '#ffffff',
    itemBorderColor: '#e0e0e0',
    itemHoverColor: '#f8f9fa',
    itemShadow: '0 2px 4px rgba(0,0,0,0.1)',
    itemBorderRadius: '8px',
    itemPadding: '16px',
    itemMargin: '8px',
    
    // 타이틀 스타일
    titleFontSize: '24px',
    titleFontWeight: 'bold',
    titleMarginBottom: '20px',
    
    // 텍스트 스타일
    nameFontSize: '16px',
    nameFontWeight: '600',
    nameColor: '#2c3e50',
    dateFontSize: '14px',
    dateColor: '#6c757d',
    idFontSize: '14px',
    idColor: '#495057',
    
    // 페이지네이션 스타일
    paginationButtonColor: '#ffffff',
    paginationButtonBorderColor: '#dee2e6',
    paginationActiveColor: '#3f51b5',
    paginationActiveTextColor: '#ffffff',
    paginationHoverColor: '#f8f9fa',
    
    // 로딩 및 상태
    loadingSpinnerColor: '#3f51b5',
    errorColor: '#dc3545',
    emptyStateColor: '#6c757d'
  }
};